module["exports"] = ["gmail.com", "yahoo.com", "hotmail.com", "nearbpo.com", "corpfolder.com"];